<template>
	<div class="card">
    <div class="card-body">
      <b-container fluid>
        <b-form @submit="onSubmit">

          <input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id" />
  <b-form-group label="Name"> 
        <b-form-input
            type="text"
            id="dataItem-name-input"
            class="form-input"
            v-model="dataItem.name"
            @blur="$v.dataItem.name.$touch()"
        ></b-form-input>
        <div class="invalid-feedback">
            <div v-if="!$v.dataItem.name.required">Name is required</div>
        </div>
        </b-form-group>
        <b-form-group label="Tracking URL"> 
        <b-form-input
            type="text"
            id="dataItem-trackingUrl-input"
            class="form-input"
            v-model="dataItem.trackingUrl"
        ></b-form-input>
        </b-form-group>
  <!-- <b-form-group label="Active">
    <b-form-checkbox 
      id="dataItem-active-input"
      class="form-input"
      v-model="dataItem.active">Active
      </b-form-checkbox>
    </b-form-group>


          <b-row>
            <b-col md="6">
              <label>Created</label>
            </b-col>
            <b-col md="6">
              <label>Modified</label>
            </b-col>
          </b-row> -->

          <b-button
            type="submit"
            variant="primary"
            style="margin: 5px;"
          >Save</b-button>
          <b-button
            style="margin: 5px;"
            @click="cancel"
          >Cancel</b-button>
        </b-form>
      </b-container>
        
    </div>

	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import service from '../../service';
import { ShippingProviderDto, ShippingProvider } from '../../dto';

export default {
  name: 'AddShippingProvider',
  components: {
    
  },
  data: () => ({
    dataItem:  ShippingProvider,
    
  }),
  methods:{
    async onSubmit(e) 
    {
      e.preventDefault();

      this.$v.dataItem.$touch();
      if (this.$v.dataItem.$invalid) {
        return;
      }
      
      let payload = new ShippingProviderDto(this.dataItem);
      payload.id = 0; //New records will start with an id of zero
      payload.active = true; 
      //New records will always be true

      try 
      {
        const id = await service.createShippingProvider(payload);
        this.dataItem.name = '';
        this.dataItem.trackingUrl = '';
        this.redirectToListing();

      } catch {}
    },
    cancel()
    {
      this.redirectToListing();
    },
    redirectToListing() 
    {
      

      this.$router.push({ name: 'ShippingProviders' });
      
    }
  },
  validations: {
    dataItem: {
      
      id:{
      },
      name:{
      },
      createdByUserId:{
      },
      modifiedByUserId:{
      },
      dateCreated:{
      },
      dateModified:{
      },
      active:{
      },
    }
  }
};
</script>
